<template>
  <v-stepper
    v-model="e1"
    alt-labels
  >
    <v-stepper-header>
      <template v-for="(step, i) in steps">
        <v-stepper-step
          :key="'step-' + i"
          :complete="e1 > i + 1"
          :step="i + 1"
          edit-icon="done"
          editable
        >
          <p class="text-center">
            {{ step }}
          </p>
        </v-stepper-step>
        <v-divider
          v-if="i + 1 < stepsNumber"
          :key="'divider-' + i"
        />
      </template>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content
        v-for="contentNumber in stepsNumber"
        :key="'content-' + contentNumber"
        :step="contentNumber"
      >
        <v-card
          class="
            d-flex
            flex-column
            justify-center
            align-center
            mb-8
            tamanhoModal
          "
          flat
        >
          <v-node
            v-for="(content, i) in tutorialContent[contentNumber - 1].children"
            :key="`children-${contentNumber}-${i}`"
            :class="{
              'text-center text-h4 font-weight-medium pa-4 primary--text':
                content.tag == 'h2',
              'mx-6 pa-4 text-center font-weight-medium text-lg-h6':
                content.tag == 'p',
            }"
            :vnode="content"
          />
        </v-card>

        <div class="d-flex justify-space-between pa-3">
          <div>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="contentNumber < stepsNumber"
                  color="error"
                  text
                  x-large
                  @click="close()"
                  v-on="on"
                >
                  <v-icon
                    dark
                    x-large
                  >
                    close
                  </v-icon>
                </v-btn>
              </template>
              <span>Clique para fechar</span>
            </v-tooltip>
          </div>

          <div>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="contentNumber > 1"
                  class="mr-2"
                  color="primary"
                  text
                  x-large
                  @click="prev"
                  v-on="on"
                >
                  <v-icon
                    dark
                    x-large
                  >
                    chevron_left
                  </v-icon>
                </v-btn>
              </template>
              <span>Clique para voltar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="contentNumber < stepsNumber"
                  color="primary"
                  text
                  x-large
                  @click="next"
                  v-on="on"
                >
                  <v-icon
                    dark
                    x-large
                  >
                    chevron_right
                  </v-icon>
                </v-btn>
              </template>
              <span>Clique para continuar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="contentNumber == stepsNumber"
                  color="success"
                  text
                  x-large
                  @click="close()"
                  v-on="on"
                >
                  <v-icon
                    dark
                    x-large
                  >
                    check
                  </v-icon>
                </v-btn>
              </template>
              <span>Clique para finalizar</span>
            </v-tooltip>
          </div>
        </div>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import VNode from '@/components/VNode';

export default {
  name: 'BaseTutorial',

  components: { VNode },

  props: {
    steps: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      e1: 1,
    };
  },

  computed: {
    stepsNumber() {
      return this.steps.length;
    },
    tutorialContent() {
      return this.$slots.default;
    },
  },

  mounted() {
    document.addEventListener('keyup', this.onKeyPress);
  },

  destroyed() {
    document.removeEventListener('keyup', this.onKeyPress);
  },

  methods: {
    next() {
      if (this.e1 < this.stepsNumber) {
        this.e1 += 1;
      }
    },
    prev() {
      if (this.e1 > 1) {
        this.e1 -= 1;
      }
    },
    onKeyPress(e) {
      if (e.keyCode === 9 && this.e1 < this.stepsNumber) {
        this.e1 += 1;
      } else if (this.e1 === this.stepsNumber && e.keyCode === 9) {
        this.e1 = 1;
      } else if (this.e1 === this.stepsNumber && e.keyCode === 13) {
        this.close();
      } else if (this.e1 <= this.stepsNumber && e.keyCode === 27) {
        this.close();
      } else if (this.e1 < this.stepsNumber && e.keyCode === 39) {
        this.e1 += 1;
      } else if (this.e1 > 1 && e.keyCode === 37) {
        this.e1 -= 1;
      }
    },
  },

  inject: ['close'],
};
</script>

<style>
.tamanhoModal {
  height: auto;
  min-height: 300px;
}
</style>
